<template>
    <div v-if="CChecked">
        <input
            type="checkbox"
            :checked="true"
            :disabled="true"
            class="checkbox inline-block align-middle "
            data-type="check-box">
    </div>
</template>

<script lang="ts" setup>

const props = defineProps({
  params: Object
})
const { params } = toRefs(props)

const CChecked = computed(() => {
  if (params?.value?.checked) {
    return true
  }
  return false
})

</script>
